import { UserActionTypes, UserSearchParams } from './types';
import { action } from 'typesafe-actions';

export const fetchUserStart = () => ({
  type: UserActionTypes.FETCH_USER_START
});

export const fetchUserSuccess = (user: any) => ({
  type: UserActionTypes.FETCH_USER_SUCCESS,
  payload: user
});

export const fetchUserFailure = (error: any) => ({
  type: UserActionTypes.FETCH_USER_FAILURE,
  payload: error
});

export const fetchUserSearchStart = (params: UserSearchParams) => ({
  type: UserActionTypes.FETCH_USER_SEARCH_START,
  payload: params
});

export const fetchUserSearchSuccess = (users: any) => ({
  type: UserActionTypes.FETCH_USER_SEARCH_SUCCESS,
  payload: users
});

export const fetchUserSearchFailure = (error: any) => ({
  type: UserActionTypes.FETCH_USER_SEARCH_FAILURE,
  payload: error
});

export const fetchApiKeysStart = () => ({
  type: UserActionTypes.FETCH_APIKEYS_START
});

export const fetchApiKeysSuccess = (apiKeys: any) => ({
  type: UserActionTypes.FETCH_APIKEYS_SUCCESS,
  payload: apiKeys
});

export const fetchApiKeysFailure = (error: any) => ({
  type: UserActionTypes.FETCH_APIKEYS_FAILURE,
  payload: error
});

export const addApiKeysStart = () => ({
  type: UserActionTypes.ADD_APIKEYS_START
});

export const addApiKeysSuccess = (apiKeys: any) => ({
  type: UserActionTypes.ADD_APIKEYS_SUCCESS,
  payload: apiKeys
});

export const addApiKeysFailure = (error: any) => ({
  type: UserActionTypes.ADD_APIKEYS_FAILURE,
  payload: error
});

export const deleteApiKeysStart = (id: any) => ({
  type: UserActionTypes.DELETE_APIKEYS_START,
  payload: { apiKeyId: id }
});

export const deleteApiKeysFailure = (error: any) => ({
  type: UserActionTypes.DELETE_APIKEYS_FAILURE,
  payload: error
});

export const updateUserStart = (user: any) => ({
  type: UserActionTypes.UPDATE_USER_START,
  payload: user
});

export const updateUserSuccess = (user: any) => ({
  type: UserActionTypes.UPDATE_USER_SUCCESS,
  payload: user
});

export const updateUserDone = () => ({
  type: UserActionTypes.UPDATE_USER_DONE
});

export const updateUserFailure = (error: any) => ({
  type: UserActionTypes.UPDATE_USER_FAILURE,
  payload: error
});
export const updateProfileUpdatingFlag = (isProfileUpdating: boolean) => ({
  type: UserActionTypes.PROFILE_UPDATING_FLAG,
  payload: { profileUpdatingFlag: isProfileUpdating }
});

export const contactSupportFlag = (isOpen: boolean) => ({
  type: UserActionTypes.CONTACT_SUPPORT_FLAG,
  payload: { contactSupportFlag: isOpen }
});

export const contactSupportStart = (req: any) => ({
  type: UserActionTypes.CONTACT_SUPPORT_START,
  payload: req
});

export const contactSupportSuccess = (res: any) => ({
  type: UserActionTypes.CONTACT_SUPPORT_SUCCESS,
  payload: res
});

export const contactSupportFailure = (error: any) => ({
  type: UserActionTypes.CONTACT_SUPPORT_FAILURE,
  payload: error
});

export const getAddressSearchSuggestStart = (payload: any) =>
  action(UserActionTypes.GET_ADDRESS_SEARCH_SUGGESTION_START, payload);

export const getAddressSearchSuggestSuccess = (payload: any) =>
  action(UserActionTypes.GET_ADDRESS_SEARCH_SUGGESTION_SUCCESS, payload);

export const getAddressSearchSuggestFailure = (payload: any) =>
  action(UserActionTypes.GET_ADDRESS_SEARCH_SUGGESTION_FAILURE, payload);

export const clearAddressSearchSuggest = () =>
  action(UserActionTypes.CLEAR_ADDRESS_SEARCH_SUGGESTION);

export const clearSupportForm = () =>
  action(UserActionTypes.CONTACT_SUPPORT_CLEAR);

export const updateShowNotificationOptionsModal = (payload: boolean) =>
  action(UserActionTypes.SHOW_NOTIFICATION_OPTIONS_MODAL, payload);

// Temporary block - need to delete after Helix enabled
export const fetchRemedyForceUserStart = () => ({
  type: UserActionTypes.FETCH_REMEDY_FORCE_USER_START
});
export const fetchRemedyForceUserSuccess = (res: any) => ({
  type: UserActionTypes.FETCH_REMEDY_FORCE_USER_SUCCESS,
  payload: res
});
export const fetchRemedyForceUserFailure = (res: any) => ({
  type: UserActionTypes.FETCH_REMEDY_FORCE_USER_FAILURE,
  payload: res
});
// Temporary block
